import { array, string, shape } from 'prop-types';
import styled from 'styled-components';

import StyledText from './StyledText';
import StyledIcon from './StyledIcon';
import { MAIN_COLOR, SMALL_TEXT, DESKTOP_SIZE } from '../../constants';

const Container = styled.div`
  margin: 8px 16px 0 0;
  display: inline-block;
`;

const StyledLabel = styled(StyledText)`
  font-size: ${({ size }) => (size ? size : { SMALL_TEXT })};
  @media (max-width: ${DESKTOP_SIZE}) {
    font-size: ${SMALL_TEXT};
  }
`;

const IconWithLabel = ({ icon, label, size }) => (
  <Container>
    <StyledIcon
      icon={icon}
      size="lg"
      color={MAIN_COLOR}
      margin="0px 10px 0px 0px"
    />
    <StyledLabel size={size} isInline>
      {label}
    </StyledLabel>
  </Container>
);

IconWithLabel.propTypes = {
  icon: shape({
    prefix: string.isRequired,
    iconName: string.isRequired,
    icon: array.isRequired,
  }).isRequired,
  label: string.isRequired,
  size: string,
};

export default IconWithLabel;



// WEBPACK FOOTER //
// components/shared/IconWithLabel.js